import { Helmet } from 'react-helmet-async';

export const ReviewSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Review",
    "itemReviewed": {
      "@type": "RealEstateAgent",
      "name": "RetailInvest by Heinrichs Immobilien"
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Kristian Keller"
    },
    "reviewBody": "Nachdem schon längere Zeit ein Makler ohne Erfolg für mich tätig war, bekam ich von einem Freund die Telefonnummer von Herrn Heinrichs. Seine von anfang an kompetente Beratung gepaart mit beeindruckendem Fachwissen in diesem nicht alltäglichen Bereich (grösserer Lebensmitteldiscounter) gaben mir das Gefühl: hier bist du gut aufgehoben. Das von Herrn Heinrichs mir nach kürzester Zeit vorgelegte hochwertige Exposé beinhaltete lückenlos alle Angaben zum Objekt mit beeindruckenden Drohnenfotos. Der Verkauf ging zügig und reibungslos über die Bühne. Die Arbeit dieses Maklers ist beeindruckend und ich kann ihn jederzeit weiterempfehlen. PS: der erzielte Verkaufspreis konnte sich mehr als sehen lassen.",
    "datePublished": "2024-12-15"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};